import { uuid } from "vue-uuid";
import { computed, ComputedRef } from "vue";
import { useStore } from "vuex";

export const key = Symbol("addHomeButtonsButton");

export interface AddHomeButtonsButtonApi {
  show: ComputedRef<boolean>;
  onClick: () => Promise<void>;
}

export default function createData(): AddHomeButtonsButtonApi {
  const store = useStore();
  return {
    show: computed(() => store.getters.showCMS),
    onClick: async () => {
      const newButton = {
        buttonId: uuid.v1(),
        type: "Twitter",
        label: "New Button",
        data: { url: "", confirmed: false },
      };
      // create deep copy
      const homeButtons = JSON.parse(
        JSON.stringify(
          store.getters.getStoreVar(
            "Home",
            "styling",
            "homeButtons",
            "homeButtons"
          )
        )
      );
      homeButtons.push(newButton);
      await store.dispatch("api/saveHomeButtonData", {
        value: homeButtons,
      });
    },
  };
}

const injectError = `Inject has failed for AddHomeButtonsButtonApi`;

export const defaultApi: AddHomeButtonsButtonApi = {
  show: computed(() => false),
  onClick: async () => console.error(injectError),
};

export const storybookApi: AddHomeButtonsButtonApi = {
  show: computed(() => false),
  onClick: async () => alert("addHomeButton clicked"),
};
